import { doc, getDoc, getFirestore } from "@firebase/firestore";

const firestore = getFirestore();

export async function getStudentsPartial(admissionNo) {
  const studentRef = doc(firestore, "students_partial", admissionNo);
  const student = await getDoc(studentRef);
  if (!student.exists()) {
    throw new Error(`Student with admission number: ${admissionNo} not found.`);
  }
  return student.data();
}
